import React from 'react';
import BaseIconSvg from '@/components/bases/BaseIconSvg';
import { Flex } from 'antd';

interface Props {
  config?: IMBodySystem[];
  objCount?: any;
  uid?: string;
  navigate: (path: string, options?: Record<string, any>) => void;
}

const PHRMobileBodySystem = ({ config = [], objCount, uid, navigate }: Props) => {
  const onClick = (c?: IMBodySystem) => {
    navigate(`/phr-mobile/medical-records/${uid}`, {
      state: { uid, bodyKey: c?.key, title: `Bệnh án ${c?.label ?? ''}` },
    });
  };

  const renderConfigItem = (c: IMBodySystem, i: number) => {
    const lastAndAlone = i === config.length - 1 && config.length % 2 === 1;
    const isEven = i % 2 === 0 && !lastAndAlone;
    const l = window.innerWidth < 800 ? 40 : 40;
    const widthItem = window.innerWidth / 2 - l;
    let count = objCount?.[c.key] ?? 0;
    if (c.key === 'other') {
      count = (objCount?.['other'] ?? 0) + (objCount?.['null'] ?? 0);
    }
    return (
      <div
        key={i.toString()}
        className={`w-1/2 mb-3 p-2 flex ${isEven ? 'flex-row-reverse' : ''} ${lastAndAlone ? 'justify-center' : 'justify-start'}`}
      >
        <div className="" style={{ width: lastAndAlone ? 0 : `${l}px` }}></div>
        <div className="group" onClick={() => onClick(c)}>
          <Flex
            gap={'5px'}
            style={{ width: widthItem > 144 ? 144 : widthItem }}
            className={`bg-white bg-opacity-35  cursor-pointer flex items-center border border-mint-3 p-2 rounded-2xl ${
              isEven ? '' : 'flex-row-reverse'
            } justify-center`}
          >
            <div className={`label-medium text-mint-13 flex flex-col flex-1 justify-center items-center ml-2`}>
              <span>{c.label}</span>
              <span>{count}</span>
            </div>
            <BaseIconSvg
              src={c.icon}
              className={` bg-mint-10 rounded-full p-2 wh-[28px] group-hover:bg-opacity-100 `}
            />
          </Flex>
        </div>
      </div>
    );
  };

  return (
    <>
      <div className="w-full justify-between flex flex-row pr-6 pl-6 mb-4 items-center">
        <span className="label-large">Hệ cơ thể</span>
        <button onClick={() => onClick()} className="bg-transparent flex items-center pr-0 text-violet-14">
          <span className="label-small mr-1">Tất cả</span>
          <BaseIconSvg src="/icons/Small/Angle Right - icon.svg" className="wh-[8px]" />
        </button>
      </div>
      <div
        className={`bg-gray-2 bg-no-repeat w-full relative`}
        style={{
          backgroundImage: 'url(/images/body_system_mobile.svg)',
          backgroundSize: '100% 100%',
          // height: HEIGHT_BG_IMAGE
        }}
      >
        <div className="flex flex-wrap justify-center relative z-[2]">{config.map(renderConfigItem)}</div>
      </div>
    </>
  );
};

export default PHRMobileBodySystem;
